import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  fill: "none",
  viewBox: "0 0 32 32"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M3.558 3.55c4.744-4.733 12.466-4.735 17.212 0a12.15 12.15 0 0 1 1.644 15.137l8.068 8.05a2.6 2.6 0 0 1 0 3.681 2.612 2.612 0 0 1-3.689 0l-8.068-8.05C14.02 25.377 7.67 24.829 3.558 20.725a12.14 12.14 0 0 1 0-17.174zm2.46 2.454a8.672 8.672 0 0 0 0 12.268 8.715 8.715 0 0 0 12.292 0 8.675 8.675 0 0 0 0-12.268 8.719 8.719 0 0 0-12.292 0z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }